export default "__VITE_ASSET__CB9ddnsa__"